<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Perfis
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e configurar
        strong  perfis
        |  e a
        strong  árvore de permissões
        |  em
        strong  Configurações → Usuários → Perfis
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Perfis → Listar
        | . Para incluir ou editar, use
        strong  Sistema → Perfis → Criar
        |  e
        strong  Sistema → Perfis → Alterar
        | . O botão
        strong  Logs
        |  (na edição) exige
        strong  Logs → Listar
        | .

      h5.h5 1. Abrir Perfis
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Expanda
          strong  Usuários
          |  e clique em
          strong  Perfis
          | .

      h5.h5 2. Listagem
      p
        | Filtre por
        strong  Descrição
        |  e pelos rádios
        strong  Ativo
        |  /
        strong  Inativo
        |  (padrão: Ativo). Cada card mostra a descrição e as datas de inserção/alteração.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de perfis")
      ol
        li Clique no
          strong  +
          |  para criar um perfil.
        li No card, clique em
          strong  Alterar
          |  para editar.

      h5.h5 3. Criar ou alterar perfil
      figure.manual-figure
        img(:src="imgForm" alt="Formulário de perfil com árvore de permissões")
      ol
        li Informe a
          strong  Descrição
          | .
        li Na edição, use o interruptor
          strong  Ativo
          | .
        li Configure as
          strong  Permissões
          |  na árvore (veja a seção seguinte).
        li Clique em
          strong  Salvar
          | . Na criação você volta à listagem; na edição permanece na tela.
        li Na edição, use
          strong  Logs
          |  ou
          strong  Listar
          |  para voltar.

      h5.h5 4. Árvore de permissões
      ol
        li Use
          strong  Pesquisar
          |  para filtrar nós da árvore.
        li Clique em
          strong  Expandir
          |  (+) ou
          strong  Recolher
          |  (−) para abrir ou fechar todos os níveis.
        li Cada nó tem um
          strong  interruptor
          |  e o rótulo da permissão (ex.: Sistema, Usuários, Listar).
        li Nós com filhos têm ícone
          strong  + / −
          |  para expandir só aquele ramo. Ícone de informação exibe dica quando houver.
        li Marcar um
          strong  pai
          |  concede o ramo inteiro e desabilita os filhos. Desmarque o pai para marcar permissões granulares nos filhos.
        li Ao salvar, as seleções são gravadas no perfil.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/39-config-perfis-lista.png"),
      imgForm: require("@/assets/manuais/39a-config-perfis-form.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
